const ITEMS = [
    "Let it rain.",
    "Your brand called. It wants a raise.",
    "Supremely rich graphics.",
    "The one of one mac. Mass produced upon request.",
    "Make money moves.",
    "Cha-ching!",
];

function Row({ hidden = false }) {
    return (
        <div
            className="flex shrink-0 items-center"
            aria-hidden={hidden || undefined}
        >
            {ITEMS.map((t, i) => (
                <span key={i} className="flex items-center">
                    <span className="px-6 font-display text-2xl uppercase leading-none md:px-10 md:text-4xl">
                        {t}
                    </span>
                    <span
                        className="inline-block h-3 w-3 rotate-45 bg-white md:h-4 md:w-4"
                        aria-hidden="true"
                    />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <section
            data-testid="brand-marquee"
            className="overflow-hidden border-y border-black/10 bg-mmm-red py-4 text-white md:py-5"
        >
            <div className="marquee-track">
                <Row />
                <Row hidden />
            </div>
        </section>
    );
}
